<div class="avatar-container">
  <span>{{userAvatarLabel}}</span>
</div>
